<template>
  <div class="app-container">
    <BjPage ref="BjPage"
      :label-width="'80px'"
      :query-params="queryParams" :col-span="colSpan"
      :get-action="queryApi" :serial="false"
      @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @afterFetchOriginalData="afterFetchOriginalData">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.profileTemplateName')" prop="keywords">
            <BjInput v-model="queryParams.keywords" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
            <el-button v-permission:BusinessBillingProfileTemplates_Edit type="primary" class="main-btn" @click="createNew">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
                <template v-if="col.prop == 'clientCodes'">
                <el-link type="primary" @click="openClient(scope.row)">{{ scope.row.clientCodes.length }}</el-link>
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-button type="text" class="edit-btn" v-permission:BusinessBillingProfileTemplates_Edit @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="delete-btn" v-permission:BusinessBillingProfileTemplates_Edit :disabled="props.row.ifUsed" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <drawerData ref="drawerData" :disabled="isDisabled" @handleConfirm="handleConfirm" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import drawerData from './components/drawerData';
import { billApi } from '@/api';
export default {
  name: 'ProfileTemplates',
  components: {
    drawerData
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,
      queryParams: {
        keywords: ''
      },
      queryApi: billApi.getProfileTemplateList,
      labelList: [
        { label: this.$t('billingPage.templateID'), prop: 'id', isCheck: true, disabled: false },
        { label: this.$t('billingPage.profileTemplateName'), prop: 'name', isCheck: true, disabled: false },
        { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('billingPage.lastUpdatedAt'), prop: 'gmtUpdate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.lastUpdatedBY'), prop: 'updatedBy', isCheck: true, disabled: false },
        { label: this.$t('billingPage.usersCount'), prop: 'clientCodes', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      isDisabled: false
    };
  },
  watch: {},
  created() {
  },
  methods: {
    openClient(item) {
      if (item.clientCodes.length == 0) return;
      this.$alert(item.clientCodes.join(','), {
        confirmButtonText: this.$t('toast.okText'),
      });
    },
    afterFetchOriginalData(res) {
      const tableList = [];
      res.content && res.content.forEach(item => {
        tableList.push({
            ...item.profileTemplate,
            clientCodes: item.clientCodes || [],
            ifUsed: item.ifUsed
        });
      });
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = tableList;
      });
    },
    handleConfirm(row) {
      if (row.id) {
        billApi.updateProfileTemplate(row).then(() => {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
        });
      } else {
        billApi.addProfileTemplateList(row).then(() => {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
        });
      }
    },
    onView(item){
      this.$refs.drawerData.drawer = true;
      this.isDisabled = true
      billApi.getProfileTemplateDetail({id: item.id}).then((res) => {
        const { id, name, enName, description } = res.data.profileTemplate;
        this.$refs.drawerData.form = {
          id, name, enName, description,
          categoryCodes: res.data.categoryCodes,
        };
        this.$refs.drawerData._getBillCategories();
      });
    },
    onEdit(item) {
      this.$refs.drawerData.drawer = true;
      this.isDisabled = false
      billApi.getProfileTemplateDetail({id: item.id}).then((res) => {
        const { id, name, enName, description } = res.data.profileTemplate;
        this.$refs.drawerData.form = {
          id, name, enName, description,
          categoryCodes: res.data.categoryCodes,
        };
        this.$refs.drawerData._getBillCategories();
      });
    },
    onDelete(item) {
      billApi.delProfileTemplate({id: item.id}).then(() => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    createNew() {
      this.$refs.drawerData.drawer = true;
      this.$refs.drawerData.form = {
        name: '', enName: '', description: '', categoryCodes: [],
      };
      this.$refs.drawerData._getBillCategories('', 'create');
    }
  },
};
</script>
